export default {"src":"/_next/static/media/vsta.56aa9f41.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};